import api from "@api";

export const fetchParkopolyAvailableSlots = async (body, params) => {
  const { data } = await api.getParkopolyAvailableSlots(body, params);

  return data;
};
